import api from "@/services/api";
export default {
  async adddebtor(formData) {
    try {
      const createDebtorData = {
        debtor: {
          company_name: formData.company_name,
          phone: formData.phone,
          street_name: formData.street_name,
          house_number: formData.house_number,
          suffix: formData.suffix,
          postal_code: formData.postal_code,
          city: formData.city,
          country: formData.country,
          invoice_email: formData.invoice_email,
          first_name: formData.first_name,
          last_name: formData.last_name,
          email: formData.email
        }
      };

      const response = await api.post("/api/v1/debtors", createDebtorData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
